import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../../core/layout/Card';
import BarChart from '../../../../core/chart/BarChart';
import Async from '../../../../core/layout/Async';

export default function ErrorsPerAbilityChart(props) {
  const total = Object.values(props.data).reduce((acc, value) => acc + value, 0);

  return (
    <Card title="Errors per Skill">
      <Async fetching={props.isFetching}>
        <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {total > 0 ? (
            <BarChart
              data={[props.data.readingErrors, props.data.listeningErrors]}
              labels={['Reading', 'Listening']}
              colors={['#009AC8', '#00C7DB']}
              options={{
                scales: {
                  yAxes: [
                    {
                      ticks: {
                        suggestedMin: 0,
                      },
                    },
                  ],
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      const value = data.datasets[0].data[tooltipItem.index];
                      return `${data.labels[tooltipItem.index]}: ${value} (${((value / total) * 100).toFixed(1)}%)`;
                    },
                  },
                },
              }}
            />
          ) : (
            <span>No errors found.</span>
          )}
        </div>
      </Async>
    </Card>
  );
}

ErrorsPerAbilityChart.propTypes = {
  data: PropTypes.object,
  isFetching: PropTypes.bool,
};

ErrorsPerAbilityChart.defaultProps = {
  isFetching: false,
};
